import React from "react";
import { Link } from "react-router-dom";
import LogoSVG from "../../images/new_logo.svg";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link" style={{ display: "inline-flex", alignItems: "center" }}>
      {/*
        new_logo.svg is an SVG containing an embedded PNG with a white/transparent bg.
        We render it inside a styled wrapper so it blends with the dark sidebar.
        mix-blend-mode: screen — makes white bg invisible on dark backgrounds.
        On light backgrounds it may look off, so we use a background-matching approach instead.
      */}
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: 6,
          padding: "2px 6px",
          background: "rgba(255,255,255,0.06)",
        }}
      >
        <img
          className="logo-img"
          src={LogoSVG}
          alt="ryzhm"
          style={{
            height: 32,
            width: "auto",
            objectFit: "contain",
            display: "block",
            // This makes the white background of the embedded PNG invisible on dark sidebar
            mixBlendMode: "screen",
          }}
        />
      </span>
    </Link>
  );
};

export default Logo;
